var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItem5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_536)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9999 16.8V21H25.1999C25.1999 18.6795 23.3204 16.8 20.9999 16.8ZM20.9999 8.4V12.6C25.6325 12.6 29.3999 16.3674 29.3999 21H33.5999C33.5999 14.0406 27.9593 8.4 20.9999 8.4ZM20.9999 0V4.2C30.263 4.2 37.7999 11.7369 37.7999 21H41.9999C41.9999 9.4017 32.5982 0 20.9999 0ZM30.7691 38.2912C30.7439 38.3668 30.746 38.3563 30.7691 38.2912V38.2912ZM29.6456 32.7141C28.1861 31.9287 26.7098 31.0337 25.1831 30.41C22.2326 29.2067 22.4321 32.7639 20.3258 33.9168C18.9566 34.6665 17.0246 33.308 15.8297 32.5562C13.7423 31.2416 11.8922 29.5115 10.355 27.5102C9.56747 26.4875 7.82868 24.564 8.04288 23.1297C8.38308 20.8533 11.0753 20.7392 10.3046 17.9546C9.89297 16.4636 9.15587 14.9962 8.60357 13.5598C7.86437 11.6341 7.55987 10.4012 5.40317 10.5062C3.84497 10.5818 2.81178 11.248 1.85418 12.4975C-0.73722 15.8722 -0.346624 20.4221 1.39428 24.1244C3.85968 29.3639 8.08487 34.3035 12.5978 37.4955C15.668 39.6669 19.7126 41.6384 23.4296 41.9723C26.1512 42.218 29.9585 40.7465 30.9329 37.7918C30.8657 37.9976 30.8006 38.1967 30.7691 38.2912C30.7922 38.2177 30.8426 38.069 30.9329 37.7918C31.0316 37.4936 31.0799 37.3443 31.103 37.2771C31.0736 37.3653 31.0064 37.5714 30.935 37.7856C31.7918 35.1816 31.8968 33.9258 29.6456 32.7141ZM31.103 37.2771C31.1198 37.2225 31.1198 37.2267 31.103 37.2771V37.2771Z",
    fill: "#21A6E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem5);
export default __webpack_public_path__ + "static/media/item5.14bb7308f3bb086c36950a24d158ab80.svg";
export { ForwardRef as ReactComponent };